import { computed, onMounted, reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import menu, { homeMenuItem } from '@/constants/menu';
import loginInfoStore from '@/store/login-info';
import type { MenuSelectedEvent } from '@/types/antd';

export default function useMenu() {
  const route = useRoute();
  const router = useRouter();

  const state = reactive({
    items: computed(() => [
      homeMenuItem,
      ...menu.filter((item) => loginInfoStore.permission.includes(item.id)),
    ]),
    selectedKeys: [] as string[],
  });

  const onMenuSelect = ({ key }: MenuSelectedEvent) => {
    router.push({ name: key as string });
  };

  onMounted(() => {
    const matched = route.matched[1];
    if (matched) state.selectedKeys = [matched.name as string];
  });

  return [state, onMenuSelect];
}
